import axios from "./axios"

/**
 * 
 * @param {*} lang 
 */
const listUserAssessment = (lang = 'ZH_TW') => {
    return axios.get(`/user-assessments?lang=${lang}`).then(res => res.data)
}

/**
 * 用戶參與模擬試
 * @param {*} courseId 
 * @param {*} lang 
 */
const assessment = (courseVersionId, lang) => {
    return axios.get(`/user-assessments/assessment?courseVersionId=${courseVersionId}&lang=${lang}`).then(res => res.data)
}

/**
 * 課程的模擬考試記錄
 * @param {*} courseId 
 * @param {*} lang 
 */
const findByCourse = (courseVersionId, lang = 'ZH_TW') => {
    return axios.get(`/user-assessments/course/${courseVersionId}?lang=${lang}`).then(res => res.data)
}

/**
 * 根據ID查找試卷詳情
 * @param {*} courseVersionId 
 * @param {*} userAssessmentId 
 */
const findByCourseAndUser = (courseVersionId, userAssessmentId, lang) => {
    return axios.get(`/user-assessments/course/${courseVersionId}/${userAssessmentId}?lang=${lang}`).then(res => res.data)
}

/**
 * 答題
 * @param {*} answerValue 
 * @param {*} currentUserQuestionAnswerId 
 * @param {*} lang 
 */
const answer = (answerValue, currentUserQuestionAnswerId, lang) => {
    return axios.post(`/user-assessments/questions/${currentUserQuestionAnswerId}/answer?lang=${lang}`, answerValue).then(res => res.data)
}

/**
 * 獲取下一題題目
 * @param {*} index 
 * @param {*} lang 
 */
const findNextQuestion = (index, lang) => {
    return axios.get(`/user-assessments/questions/${index}?lang=${lang}`).then(res => res.data)
}

/**
 * 提交試卷
 * @param {*} currentUserAssessmentId 
 * @param {*} lang 
 */
const submit = (currentUserAssessmentId, lang) => {
    return axios.post(`/user-assessments/${currentUserAssessmentId}/submit?lang=${lang}`).then(res => res.data)
}

export default {
    listUserAssessment,
    assessment,
    findByCourse,
    findByCourseAndUser,
    answer,
    findNextQuestion,
    submit
}